import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ReloadPage } from "@insite/client-framework/Store/Context/Handlers/SetLanguage";

addToChainAfter(chain, ReloadPage, props => {
    if (window.location.href.includes("isFiltered")) {
        window.location.reload();
    }
});
